import { Instance } from 'mobx-state-tree';
import { RouteStopRescheduledDtoModelBase } from './RouteStopRescheduledDtoModel.base';

/* The TypeScript type of an instance of RouteStopRescheduledDtoModel */
export interface RouteStopRescheduledDtoModelType extends Instance<typeof RouteStopRescheduledDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopRescheduledDtoModel */
export { selectFromRouteStopRescheduledDto, routeStopRescheduledDtoModelPrimitives, RouteStopRescheduledDtoModelSelector } from './RouteStopRescheduledDtoModel.base';

/**
 * RouteStopRescheduledDtoModel
 *
 * Route rescheduled event
 */
export const RouteStopRescheduledDtoModel = RouteStopRescheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
